<template>
  <div>
    <div>
      <Row span="24">
        <Col span="4">
          <h4>资产名称：{{ this.facility.facilityName }}</h4>
        </Col>
        <Col span="4">
          <h4>资产型号：{{ this.facility.facilityType }}</h4>
        </Col>
        <Col span="4">
          <h4>资产编号：{{ this.facility.assetNum }}</h4>
        </Col>
        <Col span="4">
          <h4>所在科室：{{ this.desk.deskName }}</h4>
        </Col>
        <Col span="8">
          <h4>物理位置：{{ this.facility.installationSite }}</h4>
        </Col>
      </Row>
    </div>
    <div style="margin-top: 2%">
      <Timeline>
        <TimelineItem
            color="green"
            v-for="(vv, kk) in info"
            :key="kk"
        >

          <Row span="24">
            <Col span="3" v-if="vv.repairTime != null">
              <p class="repairTime">{{ vv.repairTime }}</p>
            </Col>
          </Row>
          <Row span="24">
            <Col span="3">
              <p class="worktt">{{ vv.workTemp }}</p>
            </Col>
          </Row>
          <Row span="24">
            <Col span="5" v-if="vv.contentName != null">
              <p class="version">操作人：{{ vv.contentName }}</p>
            </Col>

            <Col span="5" v-if="vv.workNo != null">
              <p class="version">工单编号：{{ vv.workNo }}</p>
            </Col>
            <Col span="5" v-if="vv.state != null">
              <p class="version">状态：{{ vv.state }}</p>
            </Col>
          </Row>
          <Row span="24">
            <Col span="5" v-if="vv.content != null">
              <p class="version">盘点操作：{{ vv.content }}</p>
            </Col>
            <Col span="5" v-if="vv.repairBy != null">
              <p class="version">报修人：{{ vv.repairBy }}</p>
            </Col>
            <Col span="5" v-if="vv.repairPhone != null">
              <p class="version">报修电话：{{ vv.repairPhone }}</p>
            </Col>
          </Row>
          <Row span="24">
            <Col span="8" v-if="vv.descr != null">
              <p class="version">故障原因：{{ vv.descr }}</p>
            </Col>
          </Row>
          <Row span="24">
            <Col span="5" v-if="vv.maintainerName != null">
              <p class="version">处理人：{{ vv.maintainerName }}</p>
            </Col>
            <Col span="5" v-if="vv.state != null">
              <p class="version">处理结果：{{ vv.state }}</p>
            </Col>
          </Row>
          <Row span="24">
            <Col span="5" v-if="vv.finishTime != null">
              <p class="version">完成时间：{{ vv.finishTime }}</p>
            </Col>

          </Row>
          <Row span="24">
            <Col span="1" style="left: 90%;" v-if="vv.workNo != null">
              <Button @click="toInfo(vv.id)" style="background-color: #5c91f5;color: #f7f9fc" type="ghost"
                      shape="circle">详情
              </Button>
            </Col>
          </Row>

        </TimelineItem>
      </Timeline>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    kv: null,
    workId: null,
  },
  data() {
    return {
      facility: "",
      desk:"",
      info: {}
    };
  },
  async created() {
    let route = this.$route;
    this.title = route.title || "";
    let query = this.$route.query;
    if (query.kv) {
      this.kv = query.kv;
    }
    if (this.kv) {
      this.initData(this.kv);
      this.initFacility(this.kv);
    }
  },
  methods: {
    toInfo(id) {
      $utils.url.push({
        name: "workOrder_info",
        query: {action: "edit", kv: id, workId: id},
      });
    },
    initFacility(workId) {
      // 加载详情工单数据
      let id = this.kv
      $utils.api.load(`/admin/system/facility/${id}`, {}).then((res) => {
        if (res.code === 200) {
          this.facility = res.data
          this.searchdesk(this.facility.deskId)
        }
      })

    },
    searchdesk(deskId){
      // 加载详情工单数据
      let id=deskId
      $utils.api.load(`/admin/system/desk/${id}`, {}).then((res) => {
        if (res.code === 200) {
          this.desk = res.data
        }
      })
    },
    initData(workId) {
      // 加载详情工单数据
      $utils.api.load('/admin/system/work/findDetailsById', {id: this.kv}, "get").then((res) => {
        if (res.code === 200) {
          this.info = res.data;
          let dropList = [];
          let works = this.info.works
          let facilityLogs = this.info.facilityLogs
          if (works && works.length > 0) {
            for (let index = 0; index < works.length; index++) {
              const element = works[index];
              let xx = {};
              xx.id = element["id"];
              xx.workTemp = "维修信息";
              xx.workNo = element["workNo"];
              // res.data.replace(/\n/g, '<br>')
              xx.repairTime = element["repairTime"];
              xx.facilityName = element["facilityName"];
              xx.department = element["department"];
              xx.typeName = element["typeName"];
              xx.maintainerName = element["maintainerName"];
              xx.facilityNo = element["facilityNo"];
              xx.descr = element["descr"];
              xx.facilitySite = element["facilitySite"];
              xx.repairBy = element["repairBy"];
              xx.repairPhone = element["repairPhone"];
              if (element["state"] == 1) {
                xx.state = "待处理"
              } else if (element["state"] == 2) {
                xx.state = "处理中"
              } else if (element["state"] == 3) {
                xx.state = "已完成"
              }
              if (element["state"] == 3) {
                xx.finishTime = element["finishTime"];
              }

              dropList.push(xx);
            }
            this.info = dropList;
          }
          if (facilityLogs && facilityLogs.length > 0) {
            for (let index = 0; index < facilityLogs.length; index++) {
              const element = facilityLogs[index];
              let xx = {};
              xx.workTemp = "盘点信息";
              xx.repairTime = element["createTime"];
              xx.content = element["content"];
              xx.contentName = element["createBy"];
              dropList.push(xx);
            }
            this.info = dropList;
          }
        }
      });

    },
  },
};

</script>
<style scoped>
.version {

}

.worktt {
  color: #236fd3;
  font-weight: bold;
}
</style>

